module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Cup.ae8fb128.svg";